<template>
  <div>
    <spinner-block v-model="dataProgress">
      <div v-if="data">
        <gui-input v-model="data.name" :error="dataError.name" label="Название"/>
        <gui-input v-model="data.sort" :error="dataError.sort" label="Сортировка"/>

        <gui-checkbox v-model="data.is_active" :error="dataError.is_active" label="Активный"/>
        <gui-checkbox v-model="data.is_default" :error="dataError.is_default" label="Значение по умолчанию"/>


        <div class="mt-5">
          <button-save v-if="!data.id" @click="add()"/>
          <button-save v-else @click="save"/>
          <button-cancel @click="$emit('cancel')"/>
        </div>
      </div>
    </spinner-block>
  </div>
</template>

<script>


export default {
  components: {},
  data() {
    return {
      data: null,
      dataDefault: {
        is_active: '',
        is_default: '',
        name: '',
        sort: '',
      },
      dataError: {
        is_active: '',
        is_default: '',
        name: '',
        sort: '',
      },
      dataProgress: false,
    }
  },
  props: {
    id: [String, Number],
    defaultParams: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
  },
  methods: {

    init() {
      if (this.id) {
        this.data = null
        this.loadData()
      } else {
        this.data = Object.assign({}, this.dataDefault, this.defaultParams)
      }
      clearErrorList(this.dataError)
    },
    loadData() {
      axiosGetValue('/api/admin/quiz-question-option/get', {id: this.id}, e => this.data = e, e => this.dataProgress = e)
    },

    save() {
      axiosFast({
        url: route('/api/admin/quiz-question-option/update'),
        data: {data: this.data, id: this.data.id},
        error: this.dataError,
        progress: e => this.dataProgress = e,
        result: () => {
          toastSuccess('Данные сохранены');
          this.$emit('save', this.data.id)
        },
      })
    },
    add() {
      axiosFast({
        url: route('/api/admin/quiz-question-option/create'),
        data: {data: this.data},
        error: this.dataError,
        progress: e => this.dataProgress = e,
        result: (data) => {
          toastSuccess('Данные добавлены');
          this.$emit('add', data.id)
        },
      })
    },
  },
}
</script>